import { render } from "./miniMarkedList.vue?vue&type=template&id=8d961cda"
import script from "./miniMarkedList.vue?vue&type=script&lang=js"
export * from "./miniMarkedList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__